import { DepositDialogContentContainer } from './DepositDialogContentContainer'
import { DialogConfig, DialogProps } from '@/features/dialogs/common/types'
import { Dialog, DialogContent } from '@/ui/atoms/dialog/Dialog'

function DepositDialog({ token, open, setOpen }: DialogProps) {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <DepositDialogContentContainer token={token} closeDialog={() => setOpen(false)} />
      </DialogContent>
    </Dialog>
  )
}

export const depositDialogConfig: DialogConfig<DialogProps> = {
  options: {
    closeOnAccountChange: true,
  },
  element: DepositDialog,
  name: 'DepositDialog',
}
